import { ref, unref } from 'vue';
import { IUseDialogWrapperMethods } from '@ve/components/dialogWrapper/common/types';
import useVueProxy from '@ve/services/useVueProxy';

export default () => {
    const { $root } = useVueProxy();
    const railwayTourSelected = ref(false);

    const railwayToursListPopup = ref<IUseDialogWrapperMethods | null>(null);

    const open = () => {
        unref(railwayToursListPopup)?.open();
    };

    const close = () => {
        unref(railwayToursListPopup)?.close();
    };

    const selectRailwayTour = (railwayTourIdentity: string) => {
        $root?.$emit('select-railway-tour', railwayTourIdentity);
        railwayTourSelected.value = true;
    };

    return {
        selectRailwayTour,
        railwayTourSelected,
        railwayToursListPopup,
        open,
        close,
    };
};
